import React from 'react';

import LinkLayout from '../LinkLayout';
import DeckView from '../common/deck/DeckView';
import { animated } from 'react-spring';
import { App } from '@meronex/app';

export default class PositiveQuotes extends React.Component {
  state = {
    cards: null,
    fetching: false,
    fetchedCards: [],
    index: 0,
  };
  static propTypes = {};
  static defaultProps = {};

  componentDidMount() {
    this.update();
  }

  update() {
    const { index, cards, fetchedCards, fetching } = this.state;
    console.log('update...');
    if (fetchedCards.length - index < 10 && !fetching) {
      this.fetchQuotes();
    }
    if (!cards && fetchedCards.length > 0) {
      const _previousIndex = index;
      console.log(`slice range: ${_previousIndex}, ${fetchedCards.length}`);
      const _cards = fetchedCards.slice(_previousIndex, fetchedCards.length);
      if (_cards.length === 0) {
        this.fetchQuotes();
      } else {
        this.setState({
          index: fetchedCards.length,
          cards: fetchedCards.slice(_previousIndex, fetchedCards.length),
        });
      }
    }
  }

  fetchQuotes = async () => {
    const { fetchedCards = [] } = this.state;

    this.setState({ fetching: true });
    console.log('fetching...');
    const fetchRes = await window.fetch(
      'https://healthruwords.p.rapidapi.com/v1/quotes/?maxR=5&size=medium',
      {
        method: 'GET',
        headers: {
          'x-rapidapi-key':
            'nagDHP8bEDmshpFzxRiPUR63jmRPp1bOdiujsn95b9A7A4tAng',
          'x-rapidapi-host': 'healthruwords.p.rapidapi.com',
        },
      }
    );

    const jsonRes = await fetchRes.json();
    const _fetchedCards = [...fetchedCards];
    jsonRes.forEach((i) => {
      const img = new Image();
      img.src = i.media;
      if (!fetchedCards.some((c) => c.id === i.id)) {
        _fetchedCards.push(i);
      }
    });
    console.log(_fetchedCards);
    this.setState({ fetchedCards: _fetchedCards, fetching: false }, () => {
      this.update();
    });
  };

  renderContent() {
    const { cards } = this.state;
    console.log(cards);
    if (!cards || cards.length === 0) {
      return (
        <div style={{ textAlign: 'center' }}>
          <img
            style={{
              borderRadius: '10px',
              width: '100%',
              marginTop: '32vh',
              maxWidth: '600px',
            }}
            src={
              'https://cdn.dribbble.com/users/1762530/screenshots/7364756/media/ebbd1cc01f2504abfccdd7508bd90ec5.gif'
            }
          />
        </div>
      );
    }
    return (
      <div style={{ marginTop: '0px' }}>
        <DeckView
          length={cards.length}
          onSwipe={(e) => this.update(e)}
          onFinish={(e) => this.setState({ cards: null }, () => this.update())}
          renderer={(i) => {
            return (
              <div
                key={i}
                style={{
                  backgroundSize: '100% 100%',
                  backgroundImage: `url("${cards[i].media}")`,
                  backgroundColor: 'white',
                  borderRadius: '10px',
                  padding: '10px',
                  height: '450px',
                  width: '350px',
                }}></div>
            );
          }}
        />
      </div>
    );
  }

  render() {
    return (
      <LinkLayout
        showToggleTheme={true}
        headerPosition={'absolute'}
        shareUrl={'https://links.meronex.com/share/positive_quotes/index.html'}
        title={'Positive Quotes'}
        subtitle={'Positive quotes to brighten your day.'}>
        {this.renderContent()}
      </LinkLayout>
    );
  }
}
